export function hasAdmissionPermission(resource, permission) {
  try {
    const stored = sessionStorage.getItem("rolePermissions");
    if (!stored) return false;

    const parsed = JSON.parse(stored);
    const admissionPermissions = parsed["ADMISSION"];
    if (!admissionPermissions) return false;

    const resourcePermissions = admissionPermissions[resource];
    if (!resourcePermissions) return false;

    if (!permission) return true;

    return resourcePermissions.includes(permission);
  } catch (e) {
    console.error("Failed to parse rolePermissions:", e);
    return false;
  }
}